import { render } from "./Index.vue?vue&type=template&id=c23d9cb0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c23d9cb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c23d9cb0"

export default script